import { supabase } from "@/integrations/supabase/client";
import { normalizeSexToA, normalizeSexToB, isSexConstraintError } from "@/lib/normalize";
import { useSubscriptionStore } from "@/stores/subscriptionStore";

export async function ensurePatientByCPF(payload: { 
  full_name: string; 
  cpf: string; 
  celular?: string; 
  data_nascimento?: string; 
  sexo?: string;
}) {
  const user = (await supabase.auth.getUser()).data.user;
  if (!user) throw new Error("Usuário não autenticado.");

  const { data: found } = await supabase
    .from("patients_onboarding")
    .select("*")
    .eq("cpf", payload.cpf)
    .maybeSingle();

  if (found) return found;

  // Validar limite de pacientes do plano antes de criar
  const { canAddPatient } = useSubscriptionStore.getState();
  if (!canAddPatient()) {
    const { currentPlan, patientsCount } = useSubscriptionStore.getState();
    const maxPatients = currentPlan?.max_patients || 10;
    throw new Error(`Limite de pacientes atingido. Você possui ${patientsCount} pacientes ativos e seu plano permite no máximo ${maxPatients}. Faça upgrade do seu plano para adicionar mais pacientes.`);
  }

  // Tenta inserir com sexo A (M/F/O/N)
  const sexoA = normalizeSexToA(payload.sexo || null);
  const { data, error } = await supabase
    .from("patients_onboarding")
    .insert({
      owner_id: user.id,
      full_name: payload.full_name,
      cpf: payload.cpf,
      celular: payload.celular || null,
      data_nascimento: payload.data_nascimento || null,
      sexo: sexoA
    })
    .select("*")
    .single();

  // Fallback: se o banco usa pt (masculino/feminino/outro/nao_informado)
  if (isSexConstraintError(error)) {
    const sexoB = normalizeSexToB(payload.sexo || null);
    const retry = await supabase
      .from("patients_onboarding")
      .insert({
        owner_id: user.id,
        full_name: payload.full_name,
        cpf: payload.cpf,
        celular: payload.celular || null,
        data_nascimento: payload.data_nascimento || null,
        sexo: sexoB
      })
      .select("*")
      .single();
    if (retry.error) throw new Error(retry.error.message);
    
    // Atualizar contagem de pacientes no store
    useSubscriptionStore.getState().refreshPatientsCount();
    
    return retry.data;
  }

  if (error) throw new Error(error.message);
  
  // Atualizar contagem de pacientes no store
  useSubscriptionStore.getState().refreshPatientsCount();
  
  return data;
}
